import cx from 'classnames'

import { type SanityFilterGroup } from '@data/sanity/queries/types/cart'
import { type UpdateUrlParameters } from '@lib/hooks'
import { type Filter } from '@lib/product'

import Accordion from '@components/accordion'
import CollectionFilterOption from './filter-option'

interface CollectionFilterGroupProps {
  group: SanityFilterGroup
  activeFilter?: Filter
  updateParameters: UpdateUrlParameters
}

const CollectionFilterGroup = ({
  group,
  activeFilter,
  updateParameters,
}: CollectionFilterGroupProps) => {
  const id = group._key
  const groupTotal = activeFilter?.values?.length ?? 0
  const isGrid = group.display === 'grid'

  return (
    <Accordion
      id={id}
      className="border-gray"
      title={
        <>
          <span id={`filter-group-${id}`}>
            {group.title} {groupTotal > 0 && `(${groupTotal})`}
          </span>
        </>
      }
    >
      <div
        role="group"
        aria-labelledby={`filter-group-${id}`}
        className={cx('px-3 pt-1 pb-4', {
          'flex flex-wrap gap-y-3 justify-items-start': !isGrid,
          'grid grid-cols-3 gap-4': isGrid,
        })}
      >
        {group.options.map((option, index) => (
          <CollectionFilterOption
            key={index}
            option={option}
            activeFilter={activeFilter}
            isGrid={isGrid}
            updateParameters={updateParameters}
          />
        ))}
      </div>
    </Accordion>
  )
}

export default CollectionFilterGroup
